/** Non-numeric values pass through unchanged so legacy free-text entries
 *  (e.g. "every 2 weeks") still display. */
export function formatDays(value: string): string {
    const trimmed = (value ?? '').trim();
    if (!trimmed) return '';
    return /^\d+$/.test(trimmed) ? `every ${trimmed} days` : trimmed;
}

const MAX_DAYS_DIGITS = 2;

/** What a days field accepts: up to two digits, anything else dropped. */
export function normalizeDays(value: string): string {
    return (value ?? '').replace(/\D/g, '').slice(0, MAX_DAYS_DIGITS);
}
